import { render, staticRenderFns } from "./MediaPopup.vue?vue&type=template&id=006007e8&scoped=true&"
import script from "./MediaPopup.vue?vue&type=script&lang=js&"
export * from "./MediaPopup.vue?vue&type=script&lang=js&"
import style0 from "./MediaPopup.vue?vue&type=style&index=0&id=006007e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006007e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006007e8')) {
      api.createRecord('006007e8', component.options)
    } else {
      api.reload('006007e8', component.options)
    }
    module.hot.accept("./MediaPopup.vue?vue&type=template&id=006007e8&scoped=true&", function () {
      api.rerender('006007e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MediaPopup.vue"
export default component.exports